import { Text } from '@chakra-ui/react'

import { DIRECT, UNIVERSITY } from '../../enums/clientType'

const VoucherError = ({ isError, error, clientType }) => {
    const _renderVoucherErrorText = _voucherError => {
        let errorText = ''
        if (
            clientType === DIRECT &&
            _voucherError.message === 'Voucher not found'
        ) {
            errorText = 'Invalid coupon code. Please try again.'
        } else if (
            clientType === UNIVERSITY &&
            _voucherError.message === 'Voucher not found'
        ) {
            errorText = 'Invalid test code. Please try again.'
        }

        return errorText
    }

    return (
        isError && (
            <Text
                fontSize={'sm'}
                mt={6}
                color="flushmahogany"
                fontStyle={'italic'}
            >
                {_renderVoucherErrorText(error)}
            </Text>
        )
    )
}

export default VoucherError
